import { XIcon } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { HassEntity } from '@/types/hass';
import { EntitySelector } from './EntitySelector';

interface MultiEntitySelectorProps {
  value: string[];
  onChange: (value: string[]) => void;
  /** Optional entities list. If not provided, EntitySelector auto-fetches from useHass() */
  entities?: HassEntity[];
  placeholder?: string;
  className?: string;
}

export function MultiEntitySelector({
  value,
  onChange,
  entities,
  placeholder = 'Select entities...',
  className,
}: MultiEntitySelectorProps) {
  const handleAdd = (entityId: string) => {
    if (!value.includes(entityId)) {
      onChange([...value, entityId]);
    }
  };
  const handleRemove = (entityId: string) => {
    onChange(value.filter((id) => id !== entityId));
  };

  return (
    <div className={cn('space-y-1', className)}>
      <EntitySelector
        value={''}
        onChange={handleAdd}
        entities={entities}
        placeholder={placeholder}
        className="w-full"
      />
      <div className="flex flex-wrap gap-1">
        {value.map((id) => (
          <span
            key={id}
            className="inline-flex items-center rounded border bg-muted px-2 py-0.5 font-mono text-muted-foreground text-xs"
          >
            {id}
            <XIcon
              className="ml-1 h-3 w-3 cursor-pointer hover:text-destructive"
              onClick={() => handleRemove(id)}
            />
          </span>
        ))}
      </div>
    </div>
  );
}
